// extracted by mini-css-extract-plugin
module.exports = {"overlay":"_df42342"};